import React from "react";
import styles from "./style.module.css";

const MarketplaceTile = (props) => {
  const { title, subTitle, headerColor } = props;
  return (
    <div className={styles.tileContainer}>
      <div className={styles.tileHeader} style={{ backgroundColor: headerColor }}>
        <div className={styles.placeholderLogo}>Logo</div>
      </div>
      <div className={styles.tileBody}>
        <div className={styles.tileBodyTitle}>{title}</div>
        <div className={styles.tileBodySubTitle}>{subTitle}</div>
      </div>
    </div>
  );
};

export default MarketplaceTile;
